// extracted by mini-css-extract-plugin
module.exports = {"hidden":"hidden-message_hidden__3xoQm"};